import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import QmsMain from "./QmsMain";
import QmsIso17025 from "./QmsIso17025";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            maxWidth: { xs: 320, sm: "100%" },
            bgcolor: "background.paper",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label="Visão Geral" {...a11yProps(0)} />
            <Tab label="Inmetro" {...a11yProps(1)} />
            <Tab label="ISO17015" {...a11yProps(2)} />
            <Tab label="ISO9001" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <QmsMain />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Inmetro
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <QmsIso17025 />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          ISO9001
        </CustomTabPanel>
      </Box>
    </Container>
  );
}
